// extracted by mini-css-extract-plugin
module.exports = {"titleRow":"styles_titleRow__1fp3a","stickyCell":"styles_stickyCell__cn_s7","resultCell":"styles_resultCell__1DMkY","buttonsBlock":"styles_buttonsBlock__31GVn"};